var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "trbo-a-question-close-button",
      attrs: {
        "aria-label": _vm.$t("wizard.noRecommendationCloseButtonTitle"),
      },
      on: { click: _vm.onClick },
    },
    [
      _c("icon", {
        staticClass: "trbo-a-question-close-button__icon",
        attrs: { name: "close" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }